/**
 * Pavitre Theme — Minimal interactions
 * Fade-in on scroll, gallery lightbox helpers, graceful degradation
 */
(function () {
  'use strict';

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function initFadeIn() {
    var els = document.querySelectorAll('.pavitre-fade-in');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    els.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initGalleryLightbox() {
    var links = document.querySelectorAll('[data-pavitre-gallery-link]');
    if (!links.length) return;

    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        var href = link.getAttribute('href');
        if (!href || href === '#') {
          e.preventDefault();
        }
      });
    });
  }

  function initAddToCartFeedback() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('[data-pavitre-product-form]')) return;

      var btn = form.querySelector('[type="submit"]');
      if (!btn) return;

      var original = btn.textContent;
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;

      setTimeout(function () {
        btn.removeAttribute('aria-busy');
        btn.disabled = false;
        btn.textContent = original;
      }, 2000);
    });
  }

  function activateProductMedia(gallery, mediaId) {
    if (!gallery || !mediaId) return;

    gallery.querySelectorAll('[data-pavitre-thumb]').forEach(function (thumb) {
      var isActive = String(thumb.dataset.mediaId) === String(mediaId);
      thumb.classList.toggle('is-active', isActive);
      thumb.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    gallery.querySelectorAll('[data-pavitre-slide]').forEach(function (slide) {
      var isActive = String(slide.dataset.mediaId) === String(mediaId);
      slide.classList.toggle('is-active', isActive);
      slide.hidden = !isActive;
    });
  }

  function initProductGallery() {
    document.querySelectorAll('[data-pavitre-product-gallery]').forEach(function (gallery) {
      gallery.addEventListener('click', function (event) {
        var thumb = event.target.closest('[data-pavitre-thumb]');
        if (!thumb) return;
        activateProductMedia(gallery, thumb.dataset.mediaId);
      });
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event.data && event.data.variant;
        if (!variant || !variant.featured_media) return;

        document.querySelectorAll('[data-pavitre-product-gallery]').forEach(function (gallery) {
          activateProductMedia(gallery, variant.featured_media.id);
        });
      });
    }
  }

  function initProductShare() {
    document.querySelectorAll('[data-pavitre-share]').forEach(function (button) {
      button.addEventListener('click', function () {
        var url = button.getAttribute('data-pavitre-share');
        if (!url) return;

        if (navigator.share) {
          navigator.share({ url: url, title: document.title }).catch(function () {});
          return;
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).catch(function () {});
        }
      });
    });
  }

  function initProductVariantFallback() {
    document.addEventListener(
      'change',
      function (event) {
        var target = event.target;
        if (!target.matches || !target.matches('variant-selects input[type="radio"]')) return;

        var variantSelects = target.closest('variant-selects');
        if (!variantSelects) return;

        var changedFieldset = target.closest('fieldset');

        variantSelects.querySelectorAll('fieldset').forEach(function (fieldset) {
          if (fieldset === changedFieldset) return;

          var checked = fieldset.querySelector('input:checked');
          if (checked && checked.classList.contains('disabled')) {
            var firstAvailable = fieldset.querySelector('input:not(.disabled)');
            if (firstAvailable) firstAvailable.checked = true;
          }
        });
      },
      true
    );
  }

  onReady(function () {
    initFadeIn();
    initGalleryLightbox();
    initAddToCartFeedback();
    initProductGallery();
    initProductShare();
    initProductVariantFallback();
  });
})();
